import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { ChatPanel } from '@/components/chat/ChatPanel';
import { FeatureGate } from '@/components/common/FeatureGate';
import { useUIStore } from '@/stores/uiStore';
import { cn } from '@/lib/utils';

export function Layout() {
  const { sidebarCollapsed } = useUIStore();

  return (
    <div className="dls-min-h-screen dls-bg-background">
      <Sidebar />
      <div
        className={cn('dls-transition-all dls-duration-300', sidebarCollapsed ? 'lg:dls-ml-16' : 'lg:dls-ml-60')}
      >
        <Header />
        <main className="dls-py-6 dls-pb-8">
          <div className="dls-container dls-mx-auto dls-px-4 dls-max-w-7xl">
            <Outlet />
          </div>
        </main>
      </div>
      <FeatureGate feature="widget.chat.llm">
        <ChatPanel />
      </FeatureGate>
    </div>
  );
}
